import {md5} from './md5.js'

let getKey = function() {
    let phs = window.config.user.phs;

    let dateObj = new Date();
    let month = dateObj.getUTCMonth() + 1;
    let day = dateObj.getUTCDate();
    let year = dateObj.getUTCFullYear();

    let date = day + "." + month + "." + year;

    return md5(phs + date);
}

export {getKey}